import React from "react";
import "./Home.scss";
import PodcastPlayer from "../../componentes/PodcastPlayer/PodcastPlayer";

const Home = () => {
  return (
    <div className="home">
      <div className="home__content">
        <h2 className="home__content__title">ESCUCHA EL ÚLTIMO EPISODIO</h2>
        <PodcastPlayer />
      </div>
    </div>
  );
};

export default Home;
